import CollectionModule from 'client/store/modules/CollectionModule';
import CommandRunnerApi from 'client/api/v2/CommandRunnerApi';
import CommandRunnerBoundItemsApi from 'client/api/v2/CommandRunnerBoundItemsApi';

export const createCommandRunnerCollection = (Api = CommandRunnerApi, idField, sortBy) => {
  const collection = new CollectionModule(
    Api,
    idField,
    sortBy,
    CommandRunnerBoundItemsApi,
  );
  const commandRunnerCollectionModule = collection.extractModule();

  const getInitialState = () => {
    const { state } = commandRunnerCollectionModule;
    state.entities.itemDetails = {
      byId: {},
    };
    return {
      ...state,
    };
  };

  return {
    namespaced: true,

    state: getInitialState(),

    getInitialState,

    actions: {
      ...commandRunnerCollectionModule.actions,

    },

    getters: {
      ...commandRunnerCollectionModule.getters,

      getItemsToBind(state = { features: { selectedItems: { ids: [] } } }) {
        return state.features.selectedItems.ids.map(item => ({ id: item }));
      },

      getSelectedItemsCount(state) {
        const selectedItemsIds = state.features.selectedItems.ids;
        const itemsIds = state.features.items.ids;

        return selectedItemsIds.filter(selectedItemId => itemsIds.find(
          itemsId => itemsId === selectedItemId,
        )).length;
      },
    },

    mutations: {
      ...commandRunnerCollectionModule.mutations,

    },

  };
};

export default createCommandRunnerCollection(CommandRunnerApi, '_id', 'email');
